import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

@Injectable()
export abstract class ConfigurationService {
    abstract getConfiguration(key: string): Observable<any>;
    abstract getTenantConfiguration(key: string): Observable<any>;
    abstract updateTenantConfiguration(key: string, value: any): Promise<void>;
}
